import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Card, CardBody, Input, Modal, ModalHeader, ModalBody, ModalFooter, Table } from "reactstrap";
import { Link } from "react-router-dom";

import classNames from "classnames";

//import Charts
import StackedColumnChart from "./StackedColumnChart";

//import action
import { getChartsData as onGetChartsData } from "../../store/actions";

// Image
import modalimage1 from "../../assets/images/product/img-7.png";
import modalimage2 from "../../assets/images/product/img-4.png";

// Pages Components
import WelcomeComp from "./WelcomeComp";
import MonthlyEarning from "./MonthlyEarning";
import SocialSource from "./SocialSource";
import ActivityComp from "./ActivityComp";
import TopCities from "./TopCities";
import LatestTranaction from "./LatestTranaction";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

const Dashboard = props => {
  const [modal, setModal] = useState(false);
  const [subscribeModal, setSubscribeModal] = useState(false);
  
  const [agent, setAgent] = useState('')
  const [agentCode, setAgentcode] = useState('')
  const [activePolicies, setActivepolicies] = useState([])
  const [renewals, setRenewals] = useState([])
  const [expired, setExpired] = useState([])

  const [credentials, setCredentials] = useState(null)
  const [isAuth, setIsauth] = useState(false)
  const company = 'Definite'

  useEffect(()=>{
  const getCredentials =async()=>{
    const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
    const data = await res.json();
    const {Username, Password} = data;
    const cred = btoa(`${Username}:${Password}`)
    setCredentials(btoa(`${Username}:${Password}`))
    setIsauth(true)


  }
  getCredentials()

  },[])
  
    useEffect(() => {
  
        const user = localStorage.getItem('definiteagent'); // Retrieve email
        if (user) {
            
            setAgent(user)
        } else {
    
        }
        }, []);
    
    useEffect(()=>{
        const getAgentcode =async()=>{
            const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
               method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            });
            const data = await res.json();
            setAgentcode(data.OID)   

        }

       
        if(agent && isAuth){
           
            getAgentcode()
        }
    },[agent,isAuth])


    useEffect(()=>{

      const getActivepolicies =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/Activepolicies?agentCode=${agentCode}`,{
           method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        });
        const data = await res.json();
        setActivepolicies(data)
      }

      const getUpcomingRenewals =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getUpcomingrenewals?agent=${agentCode}`,{
           method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        });
        const data = await res.json();
        setRenewals(data)
      }


      const getExpired =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getExpired?agent=${agentCode}`,{
           method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        });
        const data = await res.json();
        setExpired(data)
      }
      if(agentCode && isAuth){
        getActivepolicies()
        getUpcomingRenewals();
        getExpired();
      }

    },[agentCode,isAuth])

  const DashboardProperties = createSelector(
    (state) => state.Dashboard,
    (dashboard) => ({
      chartsData: dashboard.chartsData
    })
  );

  const {
    chartsData
  } = useSelector(DashboardProperties);

  const reports = [
    { title: "All Policies", iconClass: "bx-copy-alt", description: "1,235" },
    { title: "Upcoming Renewals", iconClass: "bx-archive-in", description: "723" },
    {
      title: "Expired",
      iconClass: "bx-purchase-tag-alt",
      description: "100",
    },
  ];

  // useEffect(() => {
  //   setTimeout(() => {
  //     setSubscribeModal(true);
  //   }, 2000);
  // }, []);

  const [periodData, setPeriodData] = useState([]);
  const [periodType, setPeriodType] = useState("yearly");

  useEffect(() => {
    setPeriodData(chartsData);
  }, [chartsData]);

  const onChangeChartPeriod = pType => {
    setPeriodType(pType);
    dispatch(onGetChartsData(pType));
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(onGetChartsData("yearly"));
  }, [dispatch]);

  //meta title
  document.title = "Dashboard | Definite Agents Portal";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Dashboard")} breadcrumbItem={props.t("Definite Assurance")} />

          <Row>
            <Col xl="4">
             
              <WelcomeComp />
              <MonthlyEarning />
            </Col>
            <Col xl="8">
              <Row>
             
                  <Col md="4">
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">
                             Active Policies
                            </p>
                            <h4 className="mb-0">{activePolicies.length}</h4>
                          </div>
                          <div  style={{backgroundColor:'#0f4f48'}} className="avatar-sm rounded-circle  align-self-center mini-stat-icon">
                            {/* <span className="avatar-title rounded-circle bg-primary">
                              <i className={"bx " + report.iconClass + " font-size-24"}></i>
                            </span> */}
                          </div>
                        </div>
                      </CardBody>

                    </Card>
                  </Col>

                  <Col md="4">
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">
                             Upcoming Renewals
                            </p>
                            <h4 className="mb-0">{renewals.length}</h4>
                          </div>
                          <div style={{backgroundColor:'green'}} className="avatar-sm rounded-circle  align-self-center mini-stat-icon">
                            {/* <span className="avatar-title rounded-circle bg-primary">
                              <i className={"bx " + report.iconClass + " font-size-24"}></i>
                            </span> */}
                          </div>
                        </div>
                      </CardBody>
                      
                    </Card>
                  </Col>

                  <Col md="4">
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">
                             Expired Policies
                            </p>
                            <h4 className="mb-0">{expired.length}</h4>
                          </div>
                          <div className="avatar-sm rounded-circle bg-danger align-self-center mini-stat-icon">
                            {/* <span className="avatar-title rounded-circle bg-primary">
                              <i className={"bx " + report.iconClass + " font-size-24"}></i>
                            </span> */}
                          </div>
                        </div>
                      </CardBody>
                      
                    </Card>
                  </Col>
               
               
              </Row>
                <Card>
                                  <CardBody>
                  <div className="d-sm-flex flex-wrap">
                    <p style={{color:"#0f4f48"}} className="card-title mb-4">TO EXTEND, NAVIGATE TO 'ACTIVE POLICIES', SEARCH FOR THE POLICY, THEN CLICK 'EXTEND'</p>
                    
                  </div>

                </CardBody>
                </Card>
              <Card>

                <CardBody>
                  <div className="d-sm-flex flex-wrap">
                    <h4 className="card-title mb-4">Production</h4>
                    
                  </div>
                  {/* <div className="clearfix"></div> */}
                  <StackedColumnChart dataColors='["--bs-primary", "--bs-warning", "--bs-success"]' />
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xl="4">
              <SocialSource />
            </Col>
            <Col xl="8">
              <ActivityComp />
              <TopCities />
            </Col>

            {/* <Col xl="4">
            
            </Col> */}
          </Row>

          {/* <Row>
            <Col lg="12">
              <LatestTranaction />
            </Col>
          </Row> */}
        </Container>
      </div>

    
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);
